<template>
  <div class="container">
    <PreviousNavLink
      go-to-link="/"
      previous-label="Tillbaka till Mina organisationer"></PreviousNavLink>
    <h1 class="page-header">Registrera organisation</h1>
    <p class="intro">När du är redo att göra en ny registrering behöver du ha tillgång till ditt organisationsnummer. Du
      som gör registreringen kommer få rollen som huvudkontakt.
    </p>
    <OrderList
      :data="{title:'Registreringen har tre steg:', items:['Uppgifter om organisationen','Kontaktuppgifter', 'Granska och skicka in din registrering']}" />
    <div class="row mt-4">
      <div class="col-8">
        <div class="buttons-container spread-buttons">
          <PreviousNavLink
            go-to-link="/"
            previous-label="Tillbaka till Mina organisationer"></PreviousNavLink>
          <router-link class="btn btn-light" to="/registrering/steg-1">Gör en ny registrering &nbsp;&nbsp;<span
            class="fas fa-chevron-right"></span></router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
import OrderList from "../components/OrderList.vue";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({

  name: "PreRegView",
  components: {
    OrderList,
    PreviousNavLink
  },
  setup() {
    return {};
  }
});
</script>

<style lang="scss" scoped>
</style>